import { Container } from "@material-ui/core";
import React from "react";
import { useState, useEffect } from "react";
import toast, { Toaster } from "react-hot-toast";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import Swipeable from "../../../Fronts/Main/Swipeable";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import ConfirmAdmin from "./user-confirm";
import UserPermissions from "./user-permissions";
import { sto } from "../../../Context/InshData";
import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";

function UserPermissionsStart() {

  const tb = {
    wait: true,
    BranchDate:true,
    UsersAll:true,
    AllAccountsIndex:true,
    stor:sto,
    parms: { branch: sto.branchi ,tname:"intermed" },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );


  // const { data, fetching, fetchURL } = useFetchURL({
  //   ...{
  //     url: uri + "Users",
  //   },
  // });

  // if (fetching || !data ||!AutoOptions || !data[0]) return <LoadingPage />;
  if (fetchAll  ||!AutoOptions || !AutoOptions?.Users || !AutoOptions.Accindex) return <LoadingPage />;

  return (
  
    <UserPermissions
      users={AutoOptions?.Users}
      gData={{ user:AutoOptions?.Users[0], Form_id: 40002, id: 1 }}
      AutoOptions={AutoOptions}

      />
  );
}

export default function UserPermissionsCon() {
  const [confirmed, setConfirmed] = useState(true);

  if (!confirmed)
    return (
      <>
        <Container style={{ direction: "rtl" }}>
          <Toaster />
          <ConfirmAdmin
            keepMounted
            confirm={(pass) => {
              if (!pass) toast.error("لا يوجد لديك صلاحية للوصول");
              setConfirmed(pass);
            }}

          />
        </Container>
        <Swipeable />
      </>
    );

  return <UserPermissionsStart />;
}
